import { QTD_DEPENDENTES_ENUM } from '../../helpers/funcoesPadroes';
import {
    IDADE_ENUM,
    validarCategoria,
    validarLimiteCategoria,
    retornaLabelDoValorParentesco,
    validatorParentescoEmDuplicidade,
    validarExisteDoisDependAcima65AnosEdicao,
    validarLimiteCategoriaEdicao
} from '../zsCidadesSelecionadas/funcoesAuxiliaresZSCidades';

export class CorrenteEdicaoZSCidades {
    constructor(dependentes, parentesco, categorias, valoresForm, idadeAssociado, troca, subGrupoSelecionadoUpSell) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.categoriaSelecionada = valoresForm.Categoria;
        this.qtdDependentes = this.dependentes.length;
        this.idadeAssociado = idadeAssociado;
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;
        this.troca = subGrupoSelecionadoUpSell ? true : troca;
        this.quantidadeDependente = this.troca ? QTD_DEPENDENTES_ENUM.nove : QTD_DEPENDENTES_ENUM.sete;
        this.temDependenteEspecial = this.dependentes.some(
            categoria => categoria['CategoriaParentesco.Categoria'] !== 'ZELO'
        );
    }

    validarCategoriasPlano() {
        switch (this.valoresForm.Categoria.trim()) {
            case 'ZELO':
                if (!validarLimiteCategoria(this.dependentes, 'ZELO', this.quantidadeDependente)) {
                    this.arrayMsgsErro.push(
                        `O máximo de dependentes sem valor adicional são ${this.quantidadeDependente} dependentes.`
                    );
                    this.arrayMsgsErro.push('');
                }

                break;
            case 'ZSA64':
                if (validarLimiteCategoriaEdicao(this.dependentes)) {
                    this.arrayMsgsErro.push(
                        'O máximo de dependentes pela categoria ZELO SUPREMO ATÉ 64 ANOS é um dependente.'
                    );
                }

                break;
            case 'ZSM65':
                if (validarLimiteCategoriaEdicao(this.dependentes)) {
                    this.arrayMsgsErro.push(
                        'Neste plano, é permitido um limite máximo de um dependente com valor adicional.'
                    );
                }

                break;
        }

        if (this.valoresForm.Categoria && this.valoresForm.Categoria !== 'ZELO') {
            if (!validarCategoria(this.dependentes, this.valoresForm.Categoria)) {
                this.arrayMsgsErro.push(
                    'Para este plano só pode ser inserido um dependente especial.'
                );
            }
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    validarQtdDependentesAcima65Anos() {
        if (
            validarExisteDoisDependAcima65AnosEdicao(
                this.dependentes,
                this.valoresForm.Idade,
                this.idadeAssociado,
                this.valoresForm.Seq
            )
        ) {
            this.arrayMsgsErro.push(
                'Neste plano só é permitido duas pessoas acima de 64 anos, incluindo o titular.'
            );
        }

        return this;
    }

    verificarQuantidadeDependentes() {
        const limiteDependente = !this.temDependenteEspecial ?
            this.maximoDependentes :
            this.maximoDependentes + 1;

        if (
            this.dependentesInseridos >= this.maximoDependentes &&
            !this.temDependenteEspecial
        ) {
            if (this.valoresForm.Categoria.trim() === 'ZELO') {
                this.arrayMsgsErro.push(
                    'Ainda pode ser inserido um dependente especial.'
                );
            }
        }

        if (
            this.dependentesInseridos >= limiteDependente &&
            this.temDependenteEspecial
        ) {
            this.arrayMsgsErro.push('O máximo de dependentes foi cadastrado.');
        }

        return this;
    }

    verificarIdadeDependentes() {
        if (this.categoriaSelecionada) {
            if (
                (this.valoresForm.Idade >= IDADE_ENUM.sessentaCinco &&
                    this.valoresForm.Categoria.trim() === 'ZSA64') ||
                (this.valoresForm.Idade < IDADE_ENUM.sessentaCinco &&
                    this.valoresForm.Categoria.trim() === 'ZSM65')
            ) {
                this.arrayMsgsErro.push(
                    'A Categoria selecionada não está de acordo com a idade do dependente.'
                );
            }
        }

        return this;
    }
}
